import { ApiCall } from ".";

export async function createContact(data) {
  // The backend expects firstName / lastName, but the form has one "Full Name"
  // field. Split on the first space: first word -> firstName, the rest -> lastName.
  const fullName = (data.name || "").trim();
  const firstSpace = fullName.indexOf(" ");
  const firstName =
    firstSpace === -1 ? fullName : fullName.slice(0, firstSpace);
  const lastName =
    firstSpace === -1 ? "" : fullName.slice(firstSpace + 1).trim();

  // Field names must match the backend schema exactly (it rejects unknown keys).
  const response = await ApiCall({
    api: "/skew-contacts",
    post: true,
    map: {
      firstName,
      lastName,
      email: data.email,
      phoneNumber: data.mobile,
      companyName: data.company,
      message: data.message,
    },
  });
  return {
    state: response.success,
    message: response.message,
  };
}
